import { render, staticRenderFns } from "./PlayerLoader.vue?vue&type=template&id=0be52acf&scoped=true"
import script from "./PlayerLoader.vue?vue&type=script&lang=ts"
export * from "./PlayerLoader.vue?vue&type=script&lang=ts"
import style0 from "./PlayerLoader.vue?vue&type=style&index=0&id=0be52acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be52acf",
  null
  
)

export default component.exports